// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"jp-z","badgeLink":"kp-z","category":"lp-z"};